export default "__VITE_PUBLIC_ASSET__2655c808__"